import { render, staticRenderFns } from "./PidDashSystemMessage.vue?vue&type=template&id=13e8d29c&scoped=true&"
import script from "./PidDashSystemMessage.vue?vue&type=script&lang=js&"
export * from "./PidDashSystemMessage.vue?vue&type=script&lang=js&"
import style0 from "./PidDashSystemMessage.vue?vue&type=style&index=0&id=13e8d29c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8d29c",
  null
  
)

export default component.exports